import { IState } from './PurchaseOrders.reducer';

export interface IActions {
    [PurchaseOrdersActionTypes.setPurchaseOrder]?: IState['PurchaseOrder'];
    [PurchaseOrdersActionTypes.setLineNumber]?: IState['LineNumber'];
    [PurchaseOrdersActionTypes.setSummaryPanelData]?: IState['SummaryPanelData'];
    [PurchaseOrdersActionTypes.setProcessPurchaseOrderDetails]?: IState['ProcessPurchaseOrderDetails'];
    [PurchaseOrdersActionTypes.setReloadPurchaseOrder]?: IState['ReloadPurchaseOrder'];
    [PurchaseOrdersActionTypes.setIsChangeStatusDisabled]?: IState['IsChangeStatusDisabled'];
    [PurchaseOrdersActionTypes.setPreventChangeStatus]?: IState['PreventChangeStatus'];
}

export enum PurchaseOrdersActionTypes {
    setPurchaseOrder = 'setPurchaseOrder',
    setLineNumber = 'setLineNumber',
    setSummaryPanelData = 'setSummaryPanelData',
    setProcessPurchaseOrderDetails = 'setProcessPurchaseOrderDetails',
    setReloadPurchaseOrder = 'setReloadPurchaseOrder',
    setIsChangeStatusDisabled = 'setIsChangeStatusDisabled',
    setPreventChangeStatus = 'setPreventChangeStatus'
}
